type MinicartQuantityBadgeProps = { children: React.ReactNode };

const MinicartQuantityBadge = ({ children }: MinicartQuantityBadgeProps) => (
	<span
		className={`vtex-minicart-2-x-minicartQuantityBadge vtex-minicart-2-x-minicartQuantityBadgeDefault c-on-emphasis absolute t-mini bg-emphasis br4 w1 h1 pa1 flex justify-center items-center lh-solid`}
	>
		{children}
	</span>
);

export default MinicartQuantityBadge;
